import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import UserQueriesReport from "../components/UserQueriesReport";

const UserQueriesReportPage = () => {
  return (
    <>
      {/* MasterLayout */}
        {/* Breadcrumb */}
        <Breadcrumb title='User Queries' />

        {/* AddBlogLayer */}
        <UserQueriesReport />
    </>
  );
};

export default UserQueriesReportPage;
